/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Viewer_Misa_HintInputs */

const vi_einvoice_viewer_misa_hint = /** @type {(inputs: Einvoice_Viewer_Misa_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nội dung hóa đơn lấy từ MISA.`)
};

/**

* @param {Einvoice_Viewer_Misa_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_viewer_misa_hint = /** @type {((inputs?: Einvoice_Viewer_Misa_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Viewer_Misa_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_viewer_misa_hint(inputs)
});